<template>
  <b-modal
    id="savefilterform"
    size="sm"
    ref="savefilterform"
    body-class="bg-white"
    cancel-title="Close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Save':'Save'"
    :ok-title="page == 'create' ? 'Save' : 'Update'"
    :no-close-on-backdrop="true"
    :title="page == 'create' ? 'Save Current filter' : 'Update'"
    @ok.prevent="handleOk"
    @shown="page == 'create' ? createFreshObject() : updateObject()"
    :ok-disabled="submitted"
  >
    <b-form-group>
      <b-alert class="alert-transparent alert-danger" :show="duplicate">{{ message }}</b-alert>
      <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
        <button type="button" @click="error_show = !error_show" class="close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div v-for="item in errors.items" :key="item.id">
          <p class="fw-semi-bold">{{ item.msg }}</p>
        </div>
      </b-alert>
      <b-row>
        <b-col lg="12">
          <b-form-group label="Filter Name" label-class="required" label-for="filter-name">
            <b-form-input
              type="text"
              size="sm"
              name="filter_name"
              v-model.trim="field.filter_name"
              data-vv-name="filter name"
              v-validate="'required|max:50'"
            />
            <b-form-checkbox v-model="field.is_default" value="1" class="mt-3">Set this to Default</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>
<script>
import { mapState } from "vuex"; // get data set in the state in vuex
import { notificationMixin } from "@/mixins/notification";
export default {
  props: ["saveforfuture", "page", "item"],
  mixins: [notificationMixin],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      duplicate: false,
      error_show: false,
      message: "",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      field: {
        filter_id: "",
        filter_name: "",
        is_default: 0,
        report_type: this.$route.meta.title,
        content: this.saveforfuture
      }
    };
  },

  methods: {
    updateObject() {
      this.field.filter_name = this.item.filter_name;
      this.field.is_default = this.item.is_default;
      this.field.filter_id = this.item.filter_id;
    },
    createFreshObject() {
      this.duplicate = false;
      this.field = {
        filter_name: "",
        is_default: 0,
        report_type: this.$route.meta.title,
        content: this.saveforfuture
      };
    },
    async handleOk() {
      this.duplicate = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;

          this.$store
            .dispatch(
              "general/addsaveforfuturefilter",
              JSON.stringify(this.field)
            )
            .then(response => {
              if (response.status == 200) {
                this.$refs.savefilterform.hide();
                this.submitted = false;
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                   message: this.page=='create'?'Custom filter report was created successfully !':'Custom filter report was updated successfully !',
                  type: "success",
                  showCloseButton: true
                });
              } else {
                this.submitted = false;
                this.duplicate = true;
                this.message = response.data.status;
              }
            });
        } else {
          this.submitted = false;
          this.error_show = true;
        }
      });
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      updated_id: state => state.general.updated_id
    })
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>